import { FC, useEffect } from 'react';
import { trackEvent } from 'dibs-tracking';

import { useFragment, graphql } from 'react-relay';
import Bolt from 'dibs-icons/exports/Bolt';
import dibsCss from 'dibs-css';
import classnames from 'classnames';
import serverVars from 'server-vars';

import { PdpSharedUrgency_item$key } from './__generated__/PdpSharedUrgency_item.graphql';

type Props = {
    item: PdpSharedUrgency_item$key;
};

const itemFragment = graphql`
    fragment PdpSharedUrgency_item on Item {
        urgencyInfo(userId: $userId) {
            message
        }
    }
`;

const PdpSharedUrgency: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);
    const { urgencyInfo } = item || {};
    const isMobile = serverVars.get('settings.isMobile');

    useEffect(() => {
        trackEvent({
            category: 'product',
            action: 'urgency siderail',
            label: 'pdp',
        });
    }, []);

    return (
        <div
            className={classnames(
                dibsCss.flex,
                dibsCss.mbXxsmall,
                dibsCss.itemsCenter,
                dibsCss.textAlertsecondary,
                dibsCss.fillAlertsecondary,
                dibsCss.sassyFontBodySizeSmallTypeHeavy,
                {
                    [dibsCss.mtSmall]: isMobile,
                    [dibsCss.mbXsmall]: isMobile,
                }
            )}
        >
            <Bolt />
            <span className={dibsCss.mlXxsmall}>{urgencyInfo?.message}</span>
        </div>
    );
};

export default PdpSharedUrgency;
